import { createSlice } from '@reduxjs/toolkit';

/**
 * Redux slice for managing user authentication state.
 * Handles login, logout, and user data updates.
 *
 * State structure:
 * - data: User object or null
 * - loading: Boolean for login request status
 * - error: Error message or null
 *
 * Actions:
 * - loginStart: Sets loading to true
 * - loginSuccess: Sets user data and loading to false
 * - loginFailure: Sets error and loading to false
 * - logout: Clears user data
 * - updateUserField: Updates a specific field in user data
 */
const loginSlice = createSlice({
  name: 'login',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    loginStart(state) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    loginFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    logout(state) {
      state.data = null
    },
    updateUserField: (state, action) => {
      const { field, value } = action.payload
      if (state.data) {
        state.data[field] = value
      }
    },

  },
});

export const { loginStart, loginSuccess, loginFailure, logout, updateUserField } = loginSlice.actions;

export default loginSlice.reducer;
